import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getOperatorViolations = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/violations?${queries}` });

  return data;
};

export default getOperatorViolations;
